import React from "react";
import { default as ReactPaginate } from "react-paginate";

import { WaIcon } from "../../WaIcon";

interface PageButtonsProps extends React.Props<PageButtons> {
    maxPages: number;
    currentPage: number;
    setPage: (page: number) => void;
    style: React.CSSProperties;
    className: string;
}

export class PageButtons extends React.Component<PageButtonsProps, {}> {
    public render() {
        const { currentPage, maxPages, style, className } = this.props;

        return (
            <ReactPaginate
                previousLabel={<WaIcon name="previous" size="sm" />}
                nextLabel={<WaIcon name="next" size="sm" />}
                breakLabel={<a className="page-link">...</a>}
                breakClassName="page-item disabled"
                pageCount={maxPages}
                initialPage={currentPage - 1}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.setPage.bind(this)}
                containerClassName={className + " pagination page-buttons"}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                activeClassName="active"
                previousClassName="page-item"
                nextClassName="page-item"
                previousLinkClassName="page-link"
                nextLinkClassName="page-link"
                disabledClassName="disabled" />
        );
    }

    private setPage(data: {selected: number}) {
        this.props.setPage(data.selected + 1);
    }
}
